import React from "react";
import './styles.css';

export default function FormContainer(props) {
  const className = props.className ?? "";
  return(
    <div className={className + " form-container"}>
      {props.children}
    </div>
  );
}

export function FormRow(props) {
  const className = props.className ?? "";
  return(
    <div className={className + " form-row"}>
      {props.children}
    </div>
  );
}

export function FormButtonContainer(props) {
  const className = props.className ?? "";
  return(
    <div className={className + " form-button-container"}>
      {props.children}
    </div>
  );
}